import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ positionParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `position/getSearched`,
      params: positionParams,
    });
    const allPosition = data;
    yield put(Actions.setAll({ allPosition }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllLinePositions({ lineId }) {
  try {
    const { data } = yield call(api.get, {
      route: `position/getpositionsbyline/` + lineId,
    });
    const linePositions = data;
    yield put(Actions.setAllLinePositions({ linePositions }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdatePositions({ positionData, actionName, positionParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `position`,
      data: positionData,
    });
    yield put(Actions.fetchAll({ positionParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD ? CONSTANT_VARIABLES.POSITION_CREATED : CONSTANT_VARIABLES.POSITION_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deletePosition({ id, positionParams, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `position/${id}`,
    });
    yield put(Actions.fetchAll({ positionParams }));
    if (callback) callback();
    notification('success', CONSTANT_VARIABLES.POSITION_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}
function* changePositionOrder({ fromPositionId, toPositionId, sortAction, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.get, {
      route: `position/updatepositionsort/${fromPositionId}/${toPositionId}/${sortAction}`,
    });

    if (callback) callback();
    notification('success', CONSTANT_VARIABLES.POSITION_ORDER_CHANGED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.FETCH_ALL_BY_LINE_ID, fetchAllLinePositions),
    takeLatest(ActionTypes.ADD_OR_UPDATE_POSITION, addorUpdatePositions),
    takeLatest(ActionTypes.DELETE_POSITION, deletePosition),
    takeLatest(ActionTypes.CHANGE_POSITION_ORDER, changePositionOrder),
  ]);
}
